/*
  INAYAH — unified variant -> card thumbnail swap (one delegated handler, sitewide).

  For EVERY product card on the site:
   - select a color swatch  -> card image swaps to that color's variant image
   - hover a color swatch    -> card image previews that color (desktop / hover devices only)
   - leave the swatch area   -> restore the selected color's image (or the original)

  Handles both swatch implementations with no per-card wiring:
   - inayah-oneclick-add control: .inayah-oc__color buttons (color in data-color),
     slim [{color,image}] data in .inayah-oc__data. The element owns its own
     click-swap (swapImage()), so here we only add hover preview for it.
   - native card swatches: .variant-option-radio-input (color in value), full Shopify
     variants in [data-product-variants-json]. We own BOTH click-swap and hover here.

  Delegated on document, so lazy-loaded / AJAX-injected cards work with zero re-binding.
*/
(function () {
  if (window.__cvsInit) return;
  window.__cvsInit = true;

  var CARD_SEL = '.product-recommendations__item, .product-card, product-card, .quick-cart-product';
  var IMG_SEL = '.product-recommendations__item-media img, .product-card__media img, .media img';
  var SWATCH_SEL = '.inayah-oc__color, .variant-option-radio-input, .product-card__variants .button--variant';
  var canHover = !window.matchMedia || window.matchMedia('(hover: hover)').matches;

  function norm(s) {
    return (s == null ? '' : String(s)).toLowerCase().replace(/[\s\-–—]/g, '').replace('grey', 'gray');
  }
  function getCard(el) { return el && el.closest ? el.closest(CARD_SEL) : null; }
  function getImg(card) { return card.querySelector(IMG_SEL); }

  // color -> imageUrl map for a card, cached.
  function variantMap(card) {
    if (card._cvsMap) return card._cvsMap;
    var map = {};
    var slim = card.querySelector('.inayah-oc__data');
    if (slim) {
      try {
        JSON.parse(slim.textContent).forEach(function (v) {
          if (v.color && v.image && !map[norm(v.color)]) map[norm(v.color)] = v.image;
        });
      } catch (e) {}
    }
    var full = card.querySelector('[data-product-variants-json]');
    if (full) {
      try {
        JSON.parse(full.textContent).forEach(function (v) {
          var img = v.featured_image && (v.featured_image.src || v.featured_image);
          if (!img || !v.options) return;
          v.options.forEach(function (opt) {
            var k = norm(opt);
            if (k && !map[k]) map[k] = img;
          });
        });
      } catch (e) {}
    }
    card._cvsMap = map;
    return map;
  }
  function imageForColor(card, color) {
    return variantMap(card)[norm(color)] || null;
  }

  function colorOf(sw) {
    if (sw.classList.contains('inayah-oc__color')) return sw.dataset.color;
    if (sw.classList.contains('variant-option-radio-input')) return sw.value;
    var input = sw.querySelector ? sw.querySelector('.variant-option-radio-input') : null;
    return input ? input.value : null;
  }

  function selectedImage(card) {
    var sel = card.querySelector('.inayah-oc__color.is-selected');
    if (sel) { var i = imageForColor(card, sel.dataset.color); if (i) return i; }
    // Use the CHECKED *colour* swatch — skip size radios. querySelector(':checked') returns
    // the FIRST checked radio, which is a Size radio; resolving its value through the variant
    // map yields the wrong colour's image (e.g. size "XS" -> the first XS variant's image),
    // so restore() reverts to that colour instead of the selected one. Mirror the change
    // handler's filter: a colour swatch's holder renders a .swatch; a size's does not.
    var radios = card.querySelectorAll('.variant-option-radio-input:checked');
    for (var k = 0; k < radios.length; k++) {
      var holder = radios[k].closest('.button--variant');
      if (holder && !holder.querySelector('.product-option__swatch, .swatch')) continue;
      var j = imageForColor(card, radios[k].value);
      if (j) return j;
    }
    return null;
  }

  function allImgs(card) {
    return card.querySelectorAll(IMG_SEL);
  }
  function apply(img, url) {
    // srcset / lazy-load data-srcset override src — clear them so currentSrc updates.
    img.removeAttribute('srcset');
    img.removeAttribute('data-srcset');
    img.removeAttribute('data-src');
    img.src = url;
  }
  function setImg(card, url) {
    if (!url) return;
    allImgs(card).forEach(function (img) {
      if (img.dataset.cvsOriginal === undefined) img.dataset.cvsOriginal = img.currentSrc || img.src || '';
      apply(img, url);
    });
  }
  function restore(card) {
    var sel = selectedImage(card);
    allImgs(card).forEach(function (img) {
      var url = sel || img.dataset.cvsOriginal;
      if (url) apply(img, url);
    });
  }

  // SELECT-swap for NATIVE radios (the oneclick element owns its own click-swap).
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('variant-option-radio-input')) return;
    // Only react to COLOR swatches (which render a swatch circle) — never to the
    // hidden size radios, or a size change could pull a different color's image.
    var holder = t.closest('.button--variant');
    if (holder && !holder.querySelector('.product-option__swatch, .swatch')) return;
    var card = getCard(t);
    if (!card) return;
    var url = imageForColor(card, t.value);
    if (url) setImg(card, url);
  });

  if (canHover) {
    document.addEventListener('mouseover', function (e) {
      var sw = e.target.closest ? e.target.closest(SWATCH_SEL) : null;
      if (!sw) return;
      var card = getCard(sw);
      if (!card) return;
      var url = imageForColor(card, colorOf(sw));
      if (url) setImg(card, url);
    });
    document.addEventListener('mouseout', function (e) {
      var sw = e.target.closest ? e.target.closest(SWATCH_SEL) : null;
      if (!sw) return;
      var card = getCard(sw);
      if (!card) return;
      // Moving to another swatch in the same card? keep previewing, don't restore yet.
      var to = e.relatedTarget;
      if (to && to.closest && to.closest(SWATCH_SEL) && getCard(to) === card) return;
      restore(card);
    });
  }
})();
